module.exports = __webpack_public_path__ + "media/images/menu/csm_saudi-arabia-a07bfbedd165e36f8e1cf9ed61c83eba.png";